import React from "react";
import "./AdminDashboardHome.css";

export default function AttentionCard({ icon, tone = "warning", count, label, description, actionLabel, onAction }) {
  return (
    <div className={`adh-attention-item adh-attention-${tone}`}>
      <span className="adh-attention-icon">
        <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      </span>

      <span className="adh-attention-body">
        <span className="adh-attention-count">{count}</span>
        <span className="adh-attention-label">{label}</span>
        {description && <span className="adh-attention-desc">{description}</span>}
      </span>

      {onAction && (
        <button type="button" className="adh-attention-action" onClick={onAction}>
          {actionLabel || "View"}
          <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}
